const normalizePath = (pathname) => {
    const path = String(pathname || '/').split('?')[0].split('#')[0]
    if (path.length > 1 && path.endsWith('/')) return path.replace(/\/+$/, '')
    return path || '/'
}

const exact = (expected) => (pathname) => normalizePath(pathname) === normalizePath(expected)

const prefix = (expected) => (pathname) => {
    const path = normalizePath(pathname)
    const base = normalizePath(expected)
    return path === base || path.startsWith(`${base}/`)
}

const match = (pattern) => (pathname) => pattern.test(normalizePath(pathname))

const TOUR_ALLOWED_PATHS = {
    introdutorio: [exact('/')],
    'boas-vindas': [exact('/')],
    'novo-equipamento': [exact('/equipamento'), prefix('/equipamento/novo')],
    'editar-equipamento': [
        match(/^\/equipamento\/[^/]+\/editar(?:\/|$)/),
        prefix('/campo-parametrizado'),
        prefix('/comando-customizado'),
    ],
    parametrizacao: [prefix('/campo-parametrizado')],
    comandos: [prefix('/comando-customizado')],
    'novo-monitorado': [
        exact('/monitorado'),
        prefix('/monitorado/novo'),
        match(/^\/monitorado\/[^/]+\/editar(?:\/|$)/),
    ],
    'editar-monitorado': [match(/^\/monitorado\/[^/]+\/editar(?:\/|$)/)],
    'lista-monitorados': [prefix('/lista-monitorados'), prefix('/status')],
    'novo-perfil-cliente': [exact('/perfil/cliente'), prefix('/perfil/cliente/novo')],
    'perfil-cliente-form': [
        prefix('/perfil/cliente/novo'),
        match(/^\/perfil\/cliente\/[^/]+\/editar(?:\/|$)/),
    ],
    'perfil-cliente-pos-salvar': [match(/^\/perfil\/cliente\/[^/]+\/editar(?:\/|$)/)],
    'novo-cliente': [
        exact('/cliente'),
        prefix('/cliente/novo'),
        match(/^\/cliente\/[^/]+\/editar(?:\/|$)/),
    ],
    'cliente-pos-salvar': [match(/^\/cliente\/[^/]+\/editar(?:\/|$)/)],
    'editar-cliente': [match(/^\/cliente\/[^/]+\/editar(?:\/|$)/)],
    'reporte-manual': [exact('/virtual'), match(/^\/virtual\/[^/]+\/lancamento(?:\/|$)/)],
    'novo-automacao': [exact('/automacao'), prefix('/automacao/novo')],
    'editar-automacao': [match(/^\/automacao\/[^/]+\/editar(?:\/|$)/)],
    'novo-exportacao-dados': [exact('/exportacao-dados'), prefix('/exportacao-dados/novo')],
    'editar-exportacao-dados': [match(/^\/exportacao-dados\/[^/]+\/editar(?:\/|$)/)],
    supervisorio: [exact('/supervisorio')],
}

export const normalizeTourPath = (path) => normalizePath(path)

export const isTourAllowedPath = (tourName, pathname, savedPath) => {
    const matchers = TOUR_ALLOWED_PATHS[tourName]

    if (matchers?.length) {
        return matchers.some((matcher) => matcher(pathname))
    }

    const savedPathname = normalizePath(savedPath)
    return Boolean(savedPathname) && savedPathname === normalizePath(pathname)
}
